module.exports = __webpack_public_path__ + "img/not-found.79300ad7.svg";